const dayFormatter = new Intl.DateTimeFormat('en-US', {
    timeZone: 'America/Chicago',
    day: 'numeric',
});
const monthFormatter = new Intl.DateTimeFormat('en-US', {
    timeZone: 'America/Chicago',
    month: 'long',
});
const yearFormatter = new Intl.DateTimeFormat('en-US', {
    timeZone: 'America/Chicago',
    year: 'numeric',
});

export default function useDateSplitter() {
    const formatPart = (date: string, formatter: Intl.DateTimeFormat) => {
        if (!date) {
            return '';
        }
        const parsed = new Date(date);
        if (Number.isNaN(parsed.getTime())) {
            return '';
        }
        return formatter.format(parsed);
    };

    const getDay = (date: string) => formatPart(date, dayFormatter);
    const getMonth = (date: string) => formatPart(date, monthFormatter);
    const getYear = (date: string) => formatPart(date, yearFormatter);

    return {
        getDay,
        getMonth,
        getYear,
    };
}
